import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './filters'
import './plugins'
import i18n from './plugins/i18n'

Vue.config.productionTip = false

const $app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

store.showError = (error) => {
  $app.$toast.error($app.$t(`${error.response.data.validationErrors[0].attribute} ${error.response.data.validationErrors[0].msg}`) || 'Oops! Something went wrong!');
}

store.$toast = $app.$toast
